<template>
  <div class="ticket__information">
    <span v-if="isStart">
      <template v-if="hasPhoneNumber">
        Se inicio una interacción ”{{ formattedInteractionType }}” del número ”{{ phoneIdentifier }}” el {{ date }} a las
        {{ hour }}
      </template>
      <template v-else-if="displayUsername">
        Se inicio una interacción ”{{ formattedInteractionType }}” de ”{{ displayUsername }}” el {{ date }} a las
        {{ hour }}
      </template>
      <template v-else>
        Se inicio una interacción ”{{ formattedInteractionType }}” el {{ date }} a las
        {{ hour }}
      </template>
    </span>
    <span v-else> Interacción se finalizó el {{ date }} a las {{ hour }} </span>
  </div>
</template>

<script>
import { dateToHumanFormat, dateToHumanHour } from "@/app/shared/utils/dates";

export default {
  inject: {
    selectedChannel: { default: null },
    selectedTicket: { default: null },
  },
  props: {
    ticket: { required: true, type: Object },
    type: {
      required: true,
      type: String,
      validator: (value) => ["start", "end"].includes(value),
    },
    interaction_type: { required: false, type: [String, Number] },
    startDate: { required: false, type: [String, Date], default: null },
    channel: { required: false, type: Object, default: null },
  },
  computed: {
    channelObj() {
      return this.channel || this.selectedChannel?.value || this.selectedChannel;
    },
    isStart() {
      return this.type === "start";
    },
    time() {
      const ticket = this.ticket;
      if (this.isStart) {
        if (this.startDate) {
          return this.startDate;
        }
        const historyData = this.$store?.getters?.["getWorkspaceMessageHistory"];
        const messages = historyData?.messages || [];
        if (messages.length > 0) {
          const sorted = [...messages]
            .map((m) => m?.created_at)
            .filter(Boolean)
            .sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
          if (sorted[0]) return sorted[0];
        }
        return ticket?.created_at;
      }
      return ticket?.closed_at;
    },
    date() {
      return dateToHumanFormat(this.time);
    },
    hour() {
      return dateToHumanHour(this.time);
    },
    whatsappUsername() {
      const channelObj = this.channelObj;
      const ticketObj = this.ticket || this.selectedTicket?.value || this.selectedTicket;
      const interactions = this.$store?.getters?.["getInteractionsChannel"];
      const messages = interactions?.messages || [];
      const currentIntId = Number(this.$route?.query?.interaction);
      const currentMsgInt = messages.find((m) => m.id === currentIntId);

      const raw =
        channelObj?.whatsapp_username ||
        currentMsgInt?.whatsapp_username ||
        (!channelObj ? ticketObj?.whatsapp_username : "") ||
        "";

      if (!raw) return "";
      const trimmed = String(raw).trim();
      return trimmed.startsWith("@") ? trimmed : `@${trimmed}`;
    },
    phoneIdentifier() {
      const channelObj = this.channelObj;
      const ticketObj = this.ticket || this.selectedTicket?.value || this.selectedTicket;
      const id = channelObj?.identifier || (!channelObj ? ticketObj?.identifier : "");
      if (!id) return "";
      const strId = String(id).trim();
      if (
        strId === "" ||
        strId.toLowerCase() === "null" ||
        strId.toLowerCase() === "undefined" ||
        strId.startsWith("@") ||
        (channelObj?.whatsapp_user_id && strId === channelObj.whatsapp_user_id) ||
        (!channelObj && ticketObj?.whatsapp_user_id && strId === ticketObj.whatsapp_user_id)
      ) {
        return "";
      }
      return strId;
    },
    hasPhoneNumber() {
      return Boolean(this.phoneIdentifier);
    },
    displayUsername() {
      if (this.whatsappUsername) {
        return this.whatsappUsername;
      }
      const channelObj = this.channelObj;
      const ticketObj = this.ticket || this.selectedTicket?.value || this.selectedTicket;
      const id = channelObj?.identifier || (!channelObj ? ticketObj?.identifier : "");
      if (id && String(id).trim().startsWith("@")) {
        return String(id).trim();
      }
      return "";
    },
    formattedInteractionType() {
      const channelObj = this.channelObj;
      const ticketObj = this.ticket || this.selectedTicket?.value || this.selectedTicket;

      const rawType =
        this.interaction_type ||
        channelObj?.type_interaction ||
        ticketObj?.type_interaction;

      if (rawType === 1 || rawType === "1" || String(rawType).toLowerCase() === "inbound") {
        return "Inbound";
      }
      if (rawType === 2 || rawType === "2" || String(rawType).toLowerCase() === "outbound") {
        return "Outbound";
      }
      if (typeof rawType === "string" && rawType.trim().length > 0) {
        return rawType;
      }
      return "Inbound";
    },
  },
};
</script>

<style lang="sass">
.ticket
  &__information
    font-size: 10px
    padding: 8px 20px
    text-align: center
    border-radius: 6px
    background-color: #E3E2E2
    color: $gray-9
    margin-bottom: 10px
</style>
